import { useMutation, useQueryClient } from 'react-query'

import { addGlobalSearchRecentItem } from '../../../business-logic/use-cases/AddGlobalSearchRecentItemUseCase'
import { type AddRecentInput } from '../../../business-logic/use-cases/AddGlobalSearchRecentItemUseCase/AddGlobalSearchRecentItemUseCase'
import { globalSearchRecentsQueryConfig } from '../../../query-configs'

export const useMutateAddGlobalSearchRecentItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, unknown, AddRecentInput>({
    mutationFn: (input) =>
      Promise.resolve().then(() => addGlobalSearchRecentItem(input)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: globalSearchRecentsQueryConfig.getRecents().queryKey,
      })
    },
  })

  return { addRecentItem: mutation.mutate }
}
